import React from "react";
import PropTypes from "prop-types";
import checkAsset from "../../assets/brand/check.svg";
import pencilAsset from "../../assets/brand/pencil.svg";
import pinAsset from "../../assets/brand/pin.svg";
import locationAsset from "../../assets/brand/location.svg";
import backArrowAsset from "../../assets/brand/back-arrow.svg";
import xAsset from "../../assets/brand/x.svg";
import crosshairsAsset from "../../assets/brand/crosshairs.svg";
import fieldAsset from "../../assets/brand/field.svg";
import calendarAsset from "../../assets/brand/calendar.svg";
import clockAsset from "../../assets/brand/clock.svg";
import cashAsset from "../../assets/brand/cash.svg";
import searchAsset from "../../assets/brand/search.svg";
import officialAsset from "../../assets/brand/official.svg";
import settingsAsset from "../../assets/brand/settings.svg";
import warningAsset from "../../assets/brand/warning.svg";
import baseballAsset from "../../assets/brand/baseball.svg";
import divisionAsset from "../../assets/brand/division.svg";
import gendersAsset from "../../assets/brand/genders.svg";
import infoAsset from "../../assets/brand/info.svg";
import teamAsset from "../../assets/brand/team.svg";
import playerAsset from "../../assets/brand/player.svg";
import fanAsset from "../../assets/brand/fan.svg";
import homePlateAsset from "../../assets/brand/home-plate.svg";
import winterAsset from "../../assets/brand/winter.svg";
import summerAsset from "../../assets/brand/summer.svg";
import springAsset from "../../assets/brand/spring.svg";
import fallAsset from "../../assets/brand/fall.svg";
import questionAsset from "../../assets/brand/question.svg";
import menuAsset from "../../assets/brand/menu.svg";
import registerAsset from "../../assets/brand/register.svg";
import filtersAsset from "../../assets/brand/filters.svg";

import plusAsset from "../../assets/brand/plus.svg";

export { default as TrashIcon } from "./TrashIcon.js";

const SIZE_MAP = {
  xs: 14,
  sm: 20,
  md: 26,
  lg: 32,
  xl: 48,
};

export const resolveSize = (size) => {
  if (typeof size === "string" && SIZE_MAP[size]) {
    return SIZE_MAP[size];
  }
  return size;
};

export const BackIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={backArrowAsset}
      alt="back"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const CheckIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={checkAsset}
      alt="check"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const PinIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={pinAsset}
      alt=""
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const LocationIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={locationAsset}
      alt="location"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const PencilIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={pencilAsset}
      alt="edit"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const XIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={xAsset}
      alt="close"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const CrosshairsIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={crosshairsAsset}
      alt="snap to location"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const FieldIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={fieldAsset}
      alt="field"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const CalendarIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={calendarAsset}
      alt="calendar"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const CashIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={cashAsset}
      alt="cash"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const BaseballIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={baseballAsset}
      alt="baseball"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const DivisionIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={divisionAsset}
      alt="division"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const InfoIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={infoAsset}
      alt="info"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const GendersIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={gendersAsset}
      alt="genders"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const TeamIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={teamAsset}
      alt="team"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const PlayerIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={playerAsset}
      alt="player"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const FanIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={fanAsset}
      alt="fan"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const FiltersIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={filtersAsset}
      alt="filters"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const HomePlateIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={homePlateAsset}
      alt="home plate"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

BackIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

CheckIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

PinIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

LocationIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

PencilIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

XIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

CrosshairsIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

FieldIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

CalendarIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

CashIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

BaseballIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

DivisionIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

InfoIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

GendersIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

TeamIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

PlayerIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

FanIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

FiltersIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

HomePlateIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export const WinterIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={winterAsset}
      alt="winter"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const SummerIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={summerAsset}
      alt="summer"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const SpringIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={springAsset}
      alt="spring"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const FallIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={fallAsset}
      alt="fall"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

WinterIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

SummerIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

SpringIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

FallIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export const QuestionIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={questionAsset}
      alt="question"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const MenuIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={menuAsset}
      alt="menu"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

export const RegisterIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={registerAsset}
      alt="register"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

QuestionIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

MenuIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

RegisterIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};
export const PlusIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={plusAsset}
      alt="plus"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

PlusIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export const ClockIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={clockAsset}
      alt="time"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

ClockIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export const SearchIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={searchAsset}
      alt="search"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

SearchIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export const OfficialIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={officialAsset}
      alt="official"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

OfficialIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export const SettingsIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={settingsAsset}
      alt="settings"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

SettingsIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export const WarningIcon = ({ size = "sm", style, ...props }) => {
  const resolvedSize = resolveSize(size);
  return (
    <img
      src={warningAsset}
      alt="warning"
      aria-hidden="true"
      style={{
        width: resolvedSize,
        height: resolvedSize,
        ...style,
      }}
      {...props}
    />
  );
};

WarningIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};
